import { OrderDelivery } from '@widgets/order-delivery'

export default function OrderPage () {
  return <OrderDelivery />
}
